import { render } from "./CompanyFollowUpRecordForm.vue?vue&type=template&id=ce974172&scoped=true&ts=true"
import script from "./CompanyFollowUpRecordForm.vue?vue&type=script&lang=ts"
export * from "./CompanyFollowUpRecordForm.vue?vue&type=script&lang=ts"

import "./CompanyFollowUpRecordForm.vue?vue&type=style&index=0&id=ce974172&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce974172"]])

export default __exports__